import React, { useState } from "react";
import './ColorContrastChecker.css'; // You can define .pass and .fail classes here
import { useContext, useEffect } from "react";
import { AppContext } from "../../Context/Context";
import CommonBreadCrumb from "../../Commonalert/commonbreadcrumb";
import { Link, useParams } from "react-router-dom";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import PdfandCsv from "./PdfandCsv";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Commonfun, removeDuplicateDate } from './Commonfun';
import { ToastContainer, toast } from 'react-toastify';
import Rightsidebar from "./Rightsidebar/Rightsidebar";
import GetAppIcon from '@mui/icons-material/GetApp';
import axios from "axios";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";

function hexToRgb(hex) {
  const cleaned = hex.replace("#", "");
  const bigint = parseInt(cleaned, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return [r, g, b];
}

function luminance(r, g, b) {
  const a = [r, g, b].map(v => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
}

function getContrastRatio(fg, bg) {
  const [r1, g1, b1] = hexToRgb(fg);
  const [r2, g2, b2] = hexToRgb(bg);
  const lum1 = luminance(r1, g1, b1);
  const lum2 = luminance(r2, g2, b2);
  const bright = Math.max(lum1, lum2);
  const dark = Math.min(lum1, lum2);
  return (bright + 0.05) / (dark + 0.05);
}

const ColorContrastChecker = () => {
  const [fg, setFg] = useState("#000000");
  const [bg, setBg] = useState("#ff601f");
  const ratio = getContrastRatio(fg, bg);
  const contrast = ratio.toFixed(2);
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const [faqData, setfaqData] = useState("2")
  const [toggle, setToggle] = useState(false);
  const passAA = ratio >= 4.5;
  const passAAA = ratio >= 7;
  const passAA_Large = ratio >= 3;
  const passAAA_Large = ratio >= 4.5;
  const passUI = ratio >= 3; // Per WCAG for non-text UI
  const [isDownloading, setIsDownloading] = useState(false);
  const navigate = useNavigate();
  const esodata = useSelector((state) => state);
  const [jobidValue, setjobValue] = useState("");
  const [Domainsectiondata, SetDomainsectiondata] = useState("")
  const ApiToken = esodata.apiauthkey.value
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [DetailRunReportPopShow, SetDetailRunReportPopShow] = useState()

  const getStatus = (pass) => (
    <span className={pass ? "pass" : "fail"}>{pass ? "Pass" : "Fail"}</span>
  );
  useEffect(() => {
    faqdatafun();
  }, []);
  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };
  const faqdatafun = async (menubutval = "") => {
    // setLoading(true);
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=69`

    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (doaminsectiondatavalue?.data) {
        // console.log("faqdata",doaminsectiondatavalue.data.faqs)
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) {
      console.log('error in faqdatafun: ', err);
    } finally {
      // setLoading(false);
    }
  }
  const pdfdown = async () => {
    console.log("fg", fg)
    const foreg = fg.replace("#", "");
    const backg = bg.replace("#", "");
    setLoading(true);
    setIsDownloading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}technical/color_contrast_api/?foreground=${foreg}&background=${backg}&formats=pdf`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("Colorcontrast", "pdf", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(false);


  }
  const openMOdaltrigger = () => {
    SetDetailRunReportPopShow(true);
  };
  const CloseModalTrigger = () => {
    SetDetailRunReportPopShow(false);
  };

  return (
    <div className={`over_all_container over_all_accessibility ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  Colour Contrast Checker
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Technical' },
                      { title: 'Accessibility & Compliance' },
                      { title: 'Colour Contrast Checker', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time" style={{ borderLeft: "none" }}>
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div style={{ display: "block", textAlign: "end"}}>
                <div className="dashboard_download" style={{ justifyContent: "end", display: "inline-flex", cursor: "pointer"  }} onClick={isDownloading ? null : pdfdown}>
                  Download PDF
                  <svg
                    className="filter"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    viewBox="0 0 24 24"
                  >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-tab">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="trendy-tabs-wrapper">
                <div className="trendy-tab-container">
                  <Link to="/accessibility-score" >
                    <button type="button"
                      className={`trendy-tab`}  >Accessibility Score</button>
                  </Link>
                  <Link to="/accessibility-summary" >
                    <button type="button"
                      className={`trendy-tab`}  >Summary</button>
                  </Link>
                  <Link to="/color-checker" >
                    <button type="button"
                      className={`trendy-tab active`}  >Color Contrast Checker</button>
                  </Link>
                  <Link to="/accessibility-report" >
                    <button type="button"
                      className={`trendy-tab`}  >Report</button>
                  </Link>
                  <Link to="/accessibility-file" >
                    <button type="button"
                      className={`trendy-tab`}  >File Accessibility</button>
                  </Link>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-card-container">
        <Box className="dashboard-box-card">
          <Grid container className="dashboard-card-grid">
            <Grid item xs={12} md={12}>
              <div className="">
                <div className="color-checker-container">
                  <div className="color-row">
                    <div className="color-box">
                      <label>Foreground:</label><br />
                      <input type="color" value={fg} onChange={e => setFg(e.target.value)} />
                      <input type="text" value={fg} onChange={e => setFg(e.target.value)} />
                    </div>
                    <div className="color-box">
                      <label>Background:</label><br />
                      <input type="color" value={bg} onChange={e => setBg(e.target.value)} />
                      <input type="text" value={bg} onChange={e => setBg(e.target.value)} />
                    </div>
                  </div>

                  <h3 style={{ fontSize: "24px", color: "#0d8800" }}>
                    Contrast Ratio: <strong>{contrast}:1</strong>
                  </h3>
                  <div >
                    <div className="section">
                      <h3>Normal Text</h3>
                      <span style={{ display: "block", fontWeight: 700 }}>WCAG AA: {getStatus(passAA)} </span><br />
                      <span style={{ display: "block", fontWeight: 700 }}>WCAG AAA: {getStatus(passAAA)}</span>
                      <div className="result-preview" style={{ backgroundColor: bg, color: fg }}>
                        The five boxing wizards jump quickly.
                      </div>
                    </div>

                    <div className="section">
                      <h3>Large Text</h3>
                      <span style={{ display: "block", fontWeight: 700 }}> WCAG AA: {getStatus(passAA_Large)} </span><br />
                      <span style={{ display: "block", fontWeight: 700 }}>WCAG AAA: {getStatus(passAAA_Large)}</span>
                      <div className="result-preview" style={{ backgroundColor: bg, color: fg, fontSize: 22, fontWeight: "bold" }}>
                        The five boxing wizards jump quickly.
                      </div>
                    </div>

                    <div className="section">
                      <h3>Graphical Objects and User Interface Components</h3>
                      <span style={{ display: "block", fontWeight: 700 }}>WCAG AA: {getStatus(passUI)}</span>
                      <div className="result-preview" style={{ backgroundColor: bg }}>
                        <input
                          className="input-preview"
                          style={{
                            color: fg,
                            backgroundColor: bg,
                            border: `1px solid ${fg}`
                          }}
                          value="Text Input"
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2025 |
                  <a href="https://www.egrovesys.com/" target="blank">
                    <span className="footer-brand">eGrove Systems</span>
                  </a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p>{/* Add content if needed */}</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

      {/* <div className="top_breadcrumb_menu">
        <CommonBreadCrumb breadcrumbValue={[
          { title: 'Technical' },
          { title: 'Accessibility & Compliance' },
          { title: 'Colour Contrast Checker', activeColor: true }
        ]} />
        <div className="exportpdf_outer">
          <button onClick={handleToggle} className="faq_class exportpdf" title="Frequently Asked Question" >
            <QuestionMarkIcon />
          </button>

          <>
            <button className="exportpdf" alt="pdf icon" onClick={pdfdown} title="PDF Download" ><GetAppIcon />PDF</button>

            
          </>

        </div>
        {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}
      </div>
      <div className="cnt_hdr_top_wraps">
        <div className="cnt_hdr_top_lft_wrap">
          <div >
            <h2 className="heading_font" style={{ margin: 'auto' }}>Colour Contrast Checker</h2>
          </div>
        </div>
      </div>
      <div className="center_tab accessbility_button_tap">
        <Link to="/accessibility-score" ><button type="button" className={`runreportnews `}  >Accessibility Score</button></Link>
        <Link to="/accessibility-summary" ><button type="button" className={`runreportnews`}  >Summary</button></Link>
        <Link to="/color-checker" ><button type="button" className={`runreportnews active`}  >Color Contrast Checker</button></Link>
        <Link to="/accessibility-report" ><button type="button" className={`runreportnews`}  >Report</button></Link>
        <Link to="/accessibility-file" ><button type="button" className={`runreportnews`}  >File Accessibility</button></Link>
      </div>
      <div className="color-checker-container">
        <div className="color-row">
          <div className="color-box">
            <label>Foreground:</label><br />
            <input type="color" value={fg} onChange={e => setFg(e.target.value)} />
            <input type="text" value={fg} onChange={e => setFg(e.target.value)} />
          </div>
          <div className="color-box">
            <label>Background:</label><br />
            <input type="color" value={bg} onChange={e => setBg(e.target.value)} />
            <input type="text" value={bg} onChange={e => setBg(e.target.value)} />
          </div>
        </div>

        <h3 style={{ fontSize: "24px", color: "#0d8800" }}>
          Contrast Ratio: <strong>{contrast}:1</strong>
        </h3>
        <div >
          <div className="section">
            <h3>Normal Text</h3>
            <span style={{ display: "block", fontWeight: 700 }}>WCAG AA: {getStatus(passAA)} </span><br />
            <span style={{ display: "block", fontWeight: 700 }}>WCAG AAA: {getStatus(passAAA)}</span>
            <div className="result-preview" style={{ backgroundColor: bg, color: fg }}>
              The five boxing wizards jump quickly.
            </div>
          </div>

          <div className="section">
            <h3>Large Text</h3>
            <span style={{ display: "block", fontWeight: 700 }}> WCAG AA: {getStatus(passAA_Large)} </span><br />
            <span style={{ display: "block", fontWeight: 700 }}>WCAG AAA: {getStatus(passAAA_Large)}</span>
            <div className="result-preview" style={{ backgroundColor: bg, color: fg, fontSize: 22, fontWeight: "bold" }}>
              The five boxing wizards jump quickly.
            </div>
          </div>

          <div className="section">
            <h3>Graphical Objects and User Interface Components</h3>
            <span style={{ display: "block", fontWeight: 700 }}>WCAG AA: {getStatus(passUI)}</span>
            <div className="result-preview" style={{ backgroundColor: bg }}>
              <input
                className="input-preview"
                style={{
                  color: fg,
                  backgroundColor: bg,
                  border: `1px solid ${fg}`
                }}
                value="Text Input"
                readOnly
              />
            </div>
          </div>
        </div>
      </div> */}
    </div>

  );
};

export default ColorContrastChecker;
